import { render, staticRenderFns } from "./zhongbiao.vue?vue&type=template&id=a4b8dcfe"
import script from "./zhongbiao.vue?vue&type=script&lang=js"
export * from "./zhongbiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports